import ReactMarkdown from 'react-markdown';

export default function Markdown(props) {
  return(
    <ReactMarkdown
      linkTarget="_blank"
      {...props}
    />
  )
}